module.exports = __webpack_public_path__ + "img/company14.5fe1efaa.png";